<div class="card">
    <div class="card-header">
        <h4>{{title}}</h4>
    </div>
    <div class="card-body">
        <ejs-grid *ngIf="data" #grid [dataSource]='data' [query]='query' 
        allowPaging="true"  [pageSettings]='pageOptions' [columns]="columns"
        [editSettings]="editSettings" [toolbar]="toolbar" 
        (actionBegin)='actionBegin($event)' (actionComplete)='actionComplete($event)'
        >
        <ng-template #editSettingsTemplate let-data>
            <ng-container [ngTemplateOutlet]="editTemplate"></ng-container>
        </ng-template>
    </ejs-grid>        
    </div>
</div>